import type { SlideConfig, WrappedData, WrappedTotalsData } from '../types/wrapped'

/** Timeout in ms before falling back from video to image background */
export const VIDEO_FALLBACK_TIMEOUT_MS = 2000

export const WRAPPED_SLIDES: Array<SlideConfig> = [
  {
    id: 'intro',
    type: 'intro',
    duration: 8000,
    video: {
      id: '1152033796',
      aspectRatio: '9:16',
    },
    fallbackImageId: 'wrapped-intro-fallback',
  },
  {
    id: 'personality',
    type: 'personality',
    duration: 9000,
  },
  {
    id: 'destinations',
    type: 'stat',
    duration: 8000,
  },
  {
    id: 'nights',
    type: 'stat',
    duration: 7000,
    video: {
      id: '1151421758',
      aspectRatio: '9:16',
    },
    fallbackImageId: 'wrapped-spent-fallback',
  },
  {
    id: 'distance',
    type: 'stat',
    duration: 7000,
    video: {
      id: '1151431656',
      aspectRatio: '9:16',
    },
    fallbackImageId: 'wrapped-distance-fallback',
  },
  {
    id: 'top-destinations-quiz',
    type: 'quiz',
    duration: 7000,
  },
  {
    id: 'offer-views',
    type: 'stat',
    duration: 7000,
    video: {
      id: '1151421744',
      aspectRatio: '9:16',
    },
    fallbackImageId: 'wrapped-offers-fallback',
  },
  {
    id: 'top-offer',
    type: 'offer',
    duration: 9000,
  },
  {
    id: 'savings',
    type: 'stat',
    duration: 7000,
    video: {
      id: '1151421772',
      aspectRatio: '9:16',
    },
    fallbackImageId: 'wrapped-savings-fallback',
  },
  {
    id: 'loyalty',
    type: 'loyalty',
    duration: 9000,
  },
  {
    id: 'summary',
    type: 'summary',
    duration: 11000,
  },
  {
    id: 'prediction',
    type: 'prediction',
    duration: 9000,
    video: {
      id: '1151421780',
      aspectRatio: '9:16',
    },
    fallbackImageId: 'wrapped-prediction-fallback',
  },
]

/**
 * Returns the filtered slides based on user data conditions
 */
export function getActiveSlides(data: WrappedData): Array<SlideConfig> {
  return WRAPPED_SLIDES.filter((slide) => {
    switch (slide.id) {
      case 'top-destinations-quiz':
        return data.topDestinations.length >= 3
      case 'loyalty':
        return !!data.loyalty?.points || data.loyalty?.statusCredits
      case 'top-offer':
        return !!data.topOffer?.imageId?.length
      default:
        return true
    }
  })
}

/**
 * Returns the filtered slides for totals-only mode (when user has no wrapped data)
 * Excludes slides that require user-specific data like personality, loyalty, etc.
 */
export function getActiveSlidesForTotalsOnly(data: WrappedTotalsData): Array<SlideConfig> {
  // Slides to skip in totals-only mode (require user-specific data)
  const skipSlides = new Set<string>(['personality', 'loyalty', 'summary'])

  return WRAPPED_SLIDES.filter((slide) => {
    // Skip slides that require user-specific data
    if (skipSlides.has(slide.id)) {
      return false
    }

    switch (slide.id) {
      case 'top-destinations-quiz':
        return data.topDestinations.length >= 3
      case 'top-offer':
        return !!data.topOffer?.imageId?.length
      default:
        return true
    }
  })
}
